// Seeded randomness, ported unchanged from the prototype so a seed builds the same board there and here.

/** 32-bit FNV-1a hash of a string. */
export function fnv1a(str: string): number {
  let h = 2166136261
  for (const c of str) { h ^= c.charCodeAt(0); h = Math.imul(h, 16777619) }
  return h >>> 0
}

/** mulberry32: a small, fast PRNG returning floats in [0, 1). */
export function mulberry32(seed: number): () => number {
  let a = seed
  return function () {
    a |= 0; a = (a + 0x6d2b79f5) | 0
    let t = Math.imul(a ^ (a >>> 15), 1 | a)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

/** A PRNG seeded from a string. */
export const rngFromSeed = (seed: string): (() => number) => mulberry32(fnv1a(seed))
